import { AloftPrice, isDefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from '../orderSelectors.ts';
import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectMultiFamilyUnitsAdjs } from './selectMultiFamilyUnitsAdj.ts';

// TODO: Use this for the units adjustment plural
export const selectNumberOfUnitsAdjs = createSelector(
  [selectImprovementsEntities, selectMultiFamilyUnitsAdjs, selectCompSequence],
  (improvements, numberOfUnitsAdjs, compSequence) => {
    return compSequence.reduce((acc: Record<string, AloftPrice>, propID) => {
      const adj =
        improvements[propID]?.propertyType !== 'multiFamily'
          ? undefined
          : numberOfUnitsAdjs[propID];

      if (isDefined(adj)) acc[propID] = adj;

      return acc;
    }, {});
  },
);
